import axios from "axios";
import {
    FETCH_RECRUITERS_LIST,
    FETCH_RECRUITER_PROFILE,
    SUBMIT_RECRUITER_CONTACT,
} from "../utils/Controller/URLConstants";

export class RecruitersService {
  static async fetchRecruitersList(excludeSlug = null, workplaceId = null) {
    const params = {};
    if (excludeSlug) params.excludeSlug = excludeSlug;
    if (workplaceId) params.workplaceId = workplaceId;
    return axios.get(FETCH_RECRUITERS_LIST, {params});
  }

  static async fetchRecruiterProfile(slug) {
    return axios.get(FETCH_RECRUITER_PROFILE, {params: {slug}});
  }

  static async submitRecruiterContact(data) {
    return axios.post(SUBMIT_RECRUITER_CONTACT, data);
  }
}
